import React, { useRef } from "react";
import { motion, useInView } from "framer-motion";
import { useLanguage } from "../../contexts/LanguageContext";
import logo from "../../assets/svgs/logo circular1.png";
import "./InvestmentHero.css";

const InvestmentHero = () => {
  const { translations: tRaw } = useLanguage();
  const t = { investment: {}, ...tRaw, investment: { ...tRaw?.investment } };

  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.3 });

  return (
    <motion.section
      ref={ref}
      className="investment-hero"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
    >
      {/* soft blue glow accents */}
      <span className="bg-glow glow-top-left" />
      <span className="bg-glow glow-right" />

      <div className="hero-center">
        {/* Logo badge */}
        <motion.div
          className="hero-logo"
          initial={{ y: -12, opacity: 0, scale: 0.9 }}
          animate={
            isInView
              ? {
                  y: 0,
                  opacity: 1,
                  scale: 1,
                  transition: { duration: 0.6, delay: 0.2, ease: [0.16, 1, 0.3, 1] }
                }
              : {}
          }
        >
          <img src={logo} alt="iWinto" />
        </motion.div>

        {/* Title */}
        <motion.h1
          className="investment-hero-title gradient-title"
          initial={{ y: 16, opacity: 0 }}
          animate={
            isInView
              ? { y: 0, opacity: 1, transition: { duration: 0.7, delay: 0.35 } }
              : {}
          }
        >
          <span>
          {t.investment?.heroTitle ||
          "A Unique Investment Opportunity"}</span>
        
        </motion.h1>

        {/* Divider */}
        <motion.div
          className="title-divider"
          initial={{ scaleX: 0 }}
          animate={
            isInView
              ? {
                  scaleX: 1,
                  transition: { duration: 0.6, delay: 0.55, ease: [0.16, 1, 0.3, 1] }
                }
              : {}
          }
        />

        {/* Subtitle */}
        <motion.p
          className="investment-hero-subtitle"
          initial={{ y: 12, opacity: 0 }}
          animate={
            isInView
              ? { y: 0, opacity: 1, transition: { duration: 0.6, delay: 0.7 } }
              : {}
          }
        >
          {t.investment?.heroSubtitle ||
            "Invest in the future of technology, where innovation meets opportunity. Partner with iWinto and shape the digital commerce revolution."}
        </motion.p>

        {/* Buttons */}
        <motion.div
          className="button-row"
          initial={{ opacity: 0, y: 10 }}
          animate={
            isInView
              ? { opacity: 1, y: 0, transition: { duration: 0.6, delay: 0.9 } }
              : {}
          }
        >
          <a href="#investment-about" className="investment-hero-button primary">
            {t.investment?.learnMore || "Learn More"}
          </a>
          <a href="/contact" className="investment-hero-button secondary">
            {t.investment?.contactUs || "Contact Us"}
          </a>
        </motion.div>
      </div>
    </motion.section>
  );
};

export default InvestmentHero;
